









import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ButtonsType } from '~/types/solepro/PageBuilder';
import { trackPageBuilderButton } from '~/helpers/trackings/24orepro/components';

export default defineComponent({
    name: "Buttons",
    mixins: [PageBuilderComponent],
    components: {
        PageBuilderComponent
    },
    props: {
        node: {
            type: Object as PropType<ButtonsType>,
            required: true
        }
    },
    setup(props) {
        const { node: content } = props;
        const wrapperClasses = `gap-2
            ${content.appearance == 'stacked' ? ' w-fit flex-col' : 'w-full flex-row'}
            ${content.sameWidth == 'true' ? '--same-width !grid grid-cols-1' : 'flex'}
            `

        return {
            content,
            wrapperClasses
        }
    },
    methods: {
        manageAnchor(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            try {
                const id = evt.currentTarget.href.split('#')[1]
                const rect = document.getElementById(id).getBoundingClientRect();
                const y = rect.top + window.scrollY - 140;
                window.scrollTo(0,y)
            } catch (e) {
                console.error(e)
             }
        }
    },
    mounted() {
        this.$el.querySelectorAll('.pb_buttons [href^="#"]').forEach(el => {
            el.addEventListener('click', this.manageAnchor)
        })

        this.$el.querySelectorAll('.pb_buttons [data-sole-professionisti-track]').forEach(el => {
            el.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                const href = el.getAttribute('href');
                const target = el.getAttribute('target');
                const trackValue = el.getAttribute('data-sole-professionisti-track');
                const callback = href[0]=='#' ? ()=>{} : null; // manage editorial anchor links 
                trackPageBuilderButton(trackValue, href, target,callback);
                return
            });
        })
    },
    beforeDestroy() {
        this.$el.querySelectorAll('.pb_buttons [href^="#"]').forEach(el => {
            el.removeEventListener('click', this.manageAnchor)
        })

        this.$el.querySelectorAll('.pb_buttons [data-sole-professionisti-track]').forEach(el => {
            el.removeEventListener('click', () => {});
        })

    }
})
